<template>
  <div class="service-detail">
    <div class="label">ผู้ให้บริการ</div>
    <provider-selector
      :value="provider"
      :is-show-provider-vat="true"
      :not-clear-able="true"
      class="provider mt-2"
      @input="handleSelectProvider"
    ></provider-selector>
    <hr />
    <div class="title">รายละเอียดบริการ</div>
    <div class="label mt-2">ชื่อบริการ :</div>
    <div class="text">{{ name }}</div>
    <div class="label mt-1">รายละเอียด (อย่างย่อ) :</div>
    <div class="text">{{ shortDescription }}</div>
    <div v-if="qualityUnitText" class="label mt-1">ประเภท :</div>
    <div v-if="qualityUnitText" class="text">{{ qualityUnitText }}</div>
    <div v-if="mainOption" class="label mt-1">Option หลัก</div>
    <div class="text">{{ mainOption }}</div>
    <div v-if="extraOption" class="label mt-1">Option เสริม</div>
    <div class="text">{{ extraOption }}</div>
    <div class="label mt-1">รายละเอียด :</div>
    <div class="text">{{ description }}</div>
    <div class="label mt-1">เงื่อนไขการให้บริการ :</div>
    <div class="text">{{ termsAndConditions }}</div>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import ProviderSelector from "@/lib/components/ProviderSelector";

export default {
  components: {
    ProviderSelector
  },
  props: {
    name: { type: String, default: null },
    shortDescription: { type: String, default: null },
    description: { type: String, default: null },
    termsAndConditions: { type: String, default: null },
    provider: { type: Object, default: null },
    mainOption: { type: String, default: null },
    extraOption: { type: String, default: null },
    qualityUnitText: { type: String, default: null }
  },
  methods: {
    async handleSelectProvider(newProvider) {
      try {
        await MessageBox.confirm(`เปลี่ยนผู้ให้บริการเป็น ${newProvider.name}`, { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" });
      } catch { return; }
      this.$emit("newProvider", newProvider);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}

.label {
  color: #808080;
  font-size: 0.9rem;
}

.title,
.text {
  color: black;
  font-size: 1rem;
}

.title,
.text + .label {
  margin-top: 16px;
}

.provider {
  width: 450px;
}
</style>
